import { j as e } from '../../_virtual/jsx-runtime.js';
const s = () =>
  /* @__PURE__ */ e.jsx('div', {
    className:
      'bg-mobile-hero flex justify-center items-center bg-cover bg-center sm:bg-desktop-hero h-[290px] sm:h-[267px]',
    children: /* @__PURE__ */ e.jsxs('div', {
      className: 'bg-neutral-100 max-w-[700px] mx-5 p-5 md:p-8',
      children: [
        /* @__PURE__ */ e.jsx('h1', {
          className: 'text-heading-1 text-center mb-4',
          children: 'Welcome to Our Website',
        }),
        /* @__PURE__ */ e.jsx('p', {
          children: "Discover our services and offerings. We're glad to have you here!",
        }),
      ],
    }),
  });
export { s as Landing };
